import React from "react";

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>MORE PRODUCTS</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.title}-${i}`} className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-4">
                <div className="card h-100 shadow-sm">
                  <img
                    src={d.img}
                    alt={d.title}
                    className="card-img-top"
                    style={{ width: "100%", height: "180px", objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{d.title}</h5>
                    <p className="card-text">{d.text}</p>
                  </div>
                </div>
              </div>
            ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
